module.exports = __webpack_public_path__ + "img/home-photo.aaeb0799.jpg";